/** Склейка классов набора: пустое, false и undefined выбрасываются.
 *  Отдельной библиотеки под это не тянем — набор стилизован обычным CSS, а не
 *  утилитами Tailwind, поэтому «умное» слияние классов (tailwind-merge) не нужно. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
